import { Price } from 'lib/shared/components'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'
import React from 'react'
import { PROMO_SUB_FREQUENCY } from '../../index'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import parse, { HTMLReactParserOptions } from 'html-react-parser'

interface Props {
  promotionValue: number
  promotionalPacks: number
  promoSubTotalPieces: number
}

export const TopBlock = ({ promotionValue, promotionalPacks, promoSubTotalPieces }: Props) => {
  const staticBlock = useCmsBlock({
    id: CMS_BLOCK.PPQ_PRODUCT_RESULT,
    isLazy: false
  })

  if (!staticBlock.content) return null

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      const { attribs } = domNode

      if (!attribs) {
        return
      }

      if (attribs.id === 'frequency') {
        return <>{PROMO_SUB_FREQUENCY}</>
      }

      if (attribs.id === 'price') {
        return <Price currency={DEFAULT_CURRENCY_CODE} value={promotionValue} />
      }

      if (attribs.id === 'packs') {
        return <>{promotionalPacks} {promotionalPacks > 1 ? 'packs' : 'pack'}</>
      }

      if (attribs.id === 'pieces') {
        return <>{promoSubTotalPieces}</>
      }
    }
  }

  return (
    <>
      {staticBlock.content && (
        <div>
          {parse(staticBlock.content, options)}
        </div>
      )}
    </>
  )
}
